import React from 'react';
import {Dialog} from "primereact/dialog";
import {FileUpload} from "primereact/fileupload";
import Icon from "../../system/components/icon";
import {useTranslate} from "../../system/useTranslate";
import {fileThumbnail, getFileSize} from "../../system/utils";
import api, {getAdminUploadURL} from "../../system/api";

function UploadDialog({visible, setVisible, updateContentType, onError, uploader}) {
    const translate = useTranslate();


    const chooseOptions = {
        label:translate("choose-files"),
        className:"p-button-text border-none shadow-none text-xs flex gap-1 p-2",
        icon:<Icon icon="mi mi:attach_file" className="text-lg"/>
    }
    const uploadOptions = {
        label:translate("upload"),
        className:"p-button-text border-none shadow-none text-xs flex gap-1 p-2",
        icon:<Icon icon="mi mi:upload" className="text-lg"/>
    }
    const cancelOptions = {
        label:translate("cancel"),
        className:"p-button-text border-none shadow-none text-xs flex gap-1 p-2",
        icon:<Icon icon="mi mi:cancel" className="text-lg"/>
    }

    const ItemTemplate = (file, options)=>{
        return(
            <div className="p-2">
                <div className="surface-100 border-round justify-content-between align-items-center p-2 flex">
                    <div className="flex align-items-center gap-2">
                        <div className="flex align-items-center">
                            {fileThumbnail(file?.name, file.objectURL)}
                            {/*{options.previewElement}*/}

                        </div>
                        <div className="flex flex-column text-xs">
                            {/*<span className="white-space-nowrap font-bold text-overflow-ellipsis overflow-hidden w-full">{file?.name}</span>*/}
                            <span className="white-space-nowrap font-bold text-overflow-ellipsis overflow-hidden w-full">{options.fileNameElement}</span>
                            {/*<span className="text-400">{options.formatSize}</span>*/}
                            <span className="text-400">{`${getFileSize(options.formatSize).size} ${translate(getFileSize(options.formatSize).unit)}`}</span>
                        </div>
                    </div>
                    <div>{options.removeElement}</div>
                </div>
            </div>
        )
    }

    const EmptyTemplate = ()=>{
        return(
            <div className="flex align-items-center text-xs text-400 gap-2 justify-content-center">
                <Icon icon="mi mi:info"/>
                <span>{translate("upload-file-help")}</span>
            </div>
        )
    }

    const uploadHandler= async (e)=>{
        if (uploader) {
            // custom destination (e.g. the public help media on upload.zofino.ir); resolves {url, name}
            try {
                const file = await uploader(e.files[0]);
                updateContentType?.(file);
                setVisible(false);
                return file;
            } catch (err) {
                onError?.(err);
                return;
            }
        }
        let data = new FormData();
        data.append("files", e.files[0]);

        data.append("fileInfo", JSON.stringify({"name":e.files[0].name}));
        const url = getAdminUploadURL();
        try {
            const res = await api.post(url, data);
            updateContentType?.(res.data);
            setVisible(false);
            return res.data;
        } catch (err) {
            onError?.(err);
        }
    }

    return (
        <Dialog className="w-4 rtl" header={<Header/>} visible={visible} onHide={()=>{setVisible(false)}}>
            <FileUpload customUpload removeIcon={<Icon icon="mi mi:delete"/>} uploadHandler={uploadHandler} contentClassName="p-2" emptyTemplate={EmptyTemplate} itemTemplate={ItemTemplate} headerClassName="p-1 gap-0" chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions}/>
        </Dialog>
    );
}

function Header() {
    const translate = useTranslate();
    return(
        <span className="text-lg">
            {translate("upload-files")}
        </span>
    )
}
export default UploadDialog;
